import { from } from 'rxjs';
import { increment } from 'api/models';
import { notifications as api } from 'api/notifications';
import { makeGroup } from './make-group';
import { FetchInfo, FetchingFirstPage, Fetching, FetchedLastPage, Fetched } from './models';
export const fetch = (status, filter, content$, subscriptions, info, lastSeenAt$, selectedCompany)=>{
    const toGroup = makeGroup(status, filter, info[3], content$);
    const content = content$.value;
    const fetchCount = increment(info[1]);
    // create subscription to fetch notifications
    // and update content$ with the result
    // if the content$ is empty, we are fetching the first page
    // otherwise we are fetching the next page
    subscriptions.push(lastSeenAt$.subscribe((lastSeenAt)=>{
        if (content[0] === 'empty' || content[0] === 'fetching_first_page') {
            content$.next(FetchingFirstPage(info[1], lastSeenAt));
        } else {
            content$.next(Fetching(info, content[2], lastSeenAt));
        }
        const groups = Array.isArray(content[2]) ? content[2] : [];
        subscriptions.push(api.groups(status, filter, fetchCount, info[2], increment(info[3]), groups.map((x)=>x[1].key), selectedCompany).subscribe((result)=>{
            const current = result.map((x)=>toGroup(subscriptions, x));
            const loadMore = ([, nextCount, , notifications], nextStart)=>()=>{
                    fetch(status, filter, content$, subscriptions, FetchInfo(nextCount, nextStart, notifications), from([
                        lastSeenAt
                    ]), selectedCompany);
                };
            // if the result count is less than the fetch count we have fetched the last page
            content$.next(result.length < fetchCount[1] ? FetchedLastPage(info, groups.concat(current), lastSeenAt) : Fetched(info, groups, current, lastSeenAt, loadMore));
        }, ()=>{
            // TODO: Notify user of failure
            content$.next(content);
        }));
    }));
};
